import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import ForwardCircleRegular from './forward-circle-regular-icon.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <ForwardCircleRegular {...validProps} />;
}
SvgComponent.iconName = 'forwardCircleRegular';

export const ForwardCircleRegularIcon = svgIconWrapper(SvgComponent);
